import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import PropTypes from "prop-types";
import LoadingSpinner from "components/Common/LoadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import { put } from "helpers/api_helper";

const DetailModal = ({ isOpen, toggle, student, onSuccess }) => {
  const [data, setData] = useState({});
  const [name, setNameDefault] = useState("");
  const [newName, setNewName] = useState("");

  const [confirmAlert, setConfirmAlert] = useState(null);
  const [successAlert, setSuccessAlert] = useState(false);
  const [failedAlert, setFailedAlert] = useState(false);

  const [confimMsg, setConfirmMsg] = useState("")
  const [successMsg, setSuccessMsg] = useState("")
  const [failedMsg, setFailedMsg] = useState("")

  const [ loadingDelete, setLoadingUpdate] = useState(false);
  const [ updated, setUpdated] = useState(false);

  useEffect(() => {
      if (!isOpen) return;
      // Jika data sudah dikirim dari parent
      if (student) {
          if (student) {
            setNameDefault(student.namaSiswa ?? student.name ?? "");
            setNewName(student.namaSiswa ?? student.name ?? "");
          }
          setData(student);
          return;
      }
  }, [isOpen, student]);

  const handleUpdate = async (button) => {
    try{
      setLoadingUpdate(true);
      const body = {}
      switch(button){
        case 'unlink':
          body['family_id'] = null; break;
        case 'update':
          body['name'] = newName; break;
      }
      // await new Promise((res) => setTimeout(res, 1000));
      await put(`/student/update/data?va=${data.va}`, body)
      setSuccessMsg(`Student [${newName}] updated`)
      setSuccessAlert(true);
      setUpdated(true)
    }catch(err) {
      setFailedMsg(`Student update [${name}] failed`)
      setFailedAlert(true)
      console.error('err:',err);
    }finally {
      setLoadingUpdate(false);
      setConfirmAlert(null);
    }
  }

  return (
    <React.Fragment>
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        Student Detail
      </ModalHeader>

      <ModalBody>
      <Form>
        <FormGroup>
          <Label for="studentName">Student Name</Label>
          <Input
            id="studentName"
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />
        </FormGroup>

        <FormGroup className="mt-3">
          <Label for="studentClass">Class</Label>
          <Input
            id="studentClass"
            type="text"
            value={data?.kelas ?? ""}
            disabled
          />
        </FormGroup>

        <FormGroup className="mt-3">
          <Label for="studentVA">VA</Label>
          <Input
            id="studentVA"
            type="text"
            value={data?.va ?? ""}
            disabled
          />
        </FormGroup>
      </Form>
    </ModalBody>

    <ModalFooter className="d-flex">
      { data?.family_id ?
        <Button color="danger" onClick={() => {
          setConfirmAlert('unlink')
          setConfirmMsg(`Unlink student [${name}] from this family?`);
        }}>
          Unlink from This Family
        </Button>
      : null}

      <Button color="primary" onClick={() => {
        setConfirmAlert('update')
        setConfirmMsg(`Update student? name: [${newName}]`);
      }}>
        Update Student
      </Button>
    </ModalFooter>
    </Modal>
    {confirmAlert && (
      <SweetAlert
        warning={!loadingDelete}
        info={loadingDelete}
        showConfirm={!loadingDelete}
        showCancel={!loadingDelete}
        closeOnClickOutside={!loadingDelete}
        cancelBtnBsStyle="secondary"
        closeOnEsc={false}
        title={loadingDelete ? "Please wait" : "Are you sure?"}
        onConfirm={() => handleUpdate(confirmAlert)}
        onCancel={() => setConfirmAlert(null)}
      >
      {loadingDelete ? (
        <div className="d-flex flex-column align-items-center">
            <p className="mb-3">Updating student va: [{data.va}] data...</p>
            <LoadingSpinner />
        </div>
      ) : (
        confimMsg
      )}
        </SweetAlert>
      )}
      {successAlert && (
        <SweetAlert
          success
          title="Success"
          closeOnClickOutside={false}
          closeOnEsc={false}
          onConfirm={() => {
            setSuccessAlert(false)
            if (onSuccess && updated) {
              onSuccess(data.va);
            }
          }}
        >
          {successMsg}
        </SweetAlert>
      )}
      {failedAlert && (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => setFailedAlert(false)}
        >
          {failedMsg}
        </SweetAlert>
      )}
    </React.Fragment>
  );
};

DetailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  student: PropTypes.any.isRequired,
  onSuccess: PropTypes.func,
};

export default DetailModal;